import { SVG } from '../svg';
import { IconProps } from '../types';

export function ArrowRightIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </SVG>
  );
}
